import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { filterResults } from 'utils/functions';

const useStyles = makeStyles(theme => ({
  filter: {
    minWidth: 548,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
}));

function QuickFilter(props) {
  const classes = useStyles();
  const { rows, columns, setFilteredRows, parentFilter } = props;
  const [filter, setFilter] = useState('');

  useEffect(() => {
    if (!filter && !parentFilter) {
      setFilteredRows(rows);
    } else {
      let result = rows;
      if (filter) {
        result = filterResults(filter || '', rows, columns);
      }
      if (parentFilter) {
        result = result.filter(row => row.Parent === parentFilter);
      }
      setFilteredRows(result);
    }
    // eslint-disable-next-line
  }, [filter, rows, parentFilter]);

  const quickFilter = ev => {
    const val = ev.target.value;
    setFilter(val);
  };

  return (
    <TextField
      label="Quick filter"
      type="search"
      className={classes.filter}
      variant="outlined"
      size="small"
      onChange={quickFilter}
      value={filter}
    />
  );
}

export default QuickFilter;
